export interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
}

const variantStyles: Record<string, string> = {
  text: 'h-4 w-full rounded-md',
  circular: 'rounded-full',
  rectangular: 'h-24 w-full rounded-md',
};

export function Skeleton({ className = '', variant = 'text' }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={['animate-pulse bg-muted', variantStyles[variant], className]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
